import { Component, Input, OnInit } from '@angular/core';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { ReservationsService, SlotReservation } from '../../reservations.service';
import moment from 'moment';

@Component({
    selector: 'app-slot-reservaton-item',
    templateUrl: './slot-reservaton-item.component.html',
    styleUrls: ['./slot-reservaton-item.component.css'],
    standalone: false
})
export class SlotReservatonItemComponent implements OnInit {

  @Input() reservation: SlotReservation = new SlotReservation();
  @Input() index: number;
  public dateDiff: number;
  public icons: { [name: string]: any } = {
    'faCheck': faCheck,
  };

  constructor(private _reservationsService: ReservationsService) { }

  ngOnInit(): void {
    this.dateDiff = moment(this.reservation.reservationDate).diff(moment(), 'days');
  }

  onReservationApproveClick(index: number) {
    this._reservationsService.approveSlotReservationSubject.next(index);
  }
}
